// 個人信息模塊
export default {
    Personal: {
        SetPassword: '設置密碼',
        PleaseEnterPassword: '請輸入密碼',
        PleaseEnterPasswordAgain: '請再次輸入密碼',
        ChangePassword: '修改密碼',
        PleaseEnterOldPassword: '請 輸 入 舊 密 碼',
        PleaseEnterOldPassword2: '請輸入舊密碼',
        PleaseEterNewPassword: '請 輸 入 新 密 碼',
        PleaseEterNewPassword2: '請輸入新密碼',
        PleaseEnterNewPasswordAgain: '請再次輸入新密碼',
        ModifyAvatar: '修改頭像',
        LocalUpload: '本地上傳',
        LocalUploadTip: '僅支持JPG、GIF、PNG、JPEG、BMP格式，文件小於5M',
        EffectPreview: '效果預覽',
        Pixels: '100*100像素',
        UserInformation: '用戶信息',
        HeadPortrait: '頭像:',
        ReplaceAvatar: '更換頭像',
        UserName: '用戶名:',
        EnterUserName: '請輸入用戶名',
        UserNameCanOnlyModifiedOnce: '用戶名只可修改一次',
        ModifyUserName: '修改用戶名',
        NewUsername: '新用戶名',
        CellPhoneNumber: '手機號:',
        PleaseEnterPhoneNumber: '請輸入手機號',
        PleaseBindPhoneNumber: '根據網信辦規定，發布信息必須綁定手機號，請您及時綁定手機號。',
        UnbindPhoneNumber: '解綁手機號',
        BindPhoneNumber: '綁定手機號',
        PleaseEnterYourPhoneNumber: '請輸入您的手機號',
        PleaseEnterVerificationCode: '請輸入驗證碼',
        SendVerificationCode: '發送驗證碼',
        Resend: '重新發送',
        Password: '密碼：',
        Mailbox: '郵箱：',
        SetUpEmail: '設置郵箱',
        BindEmail: '綁定郵箱',
        ModifyEmail: '修改郵箱',
        VerifyEmailAddress: '驗證郵件地址',
        EmailAddress: '郵件地址',
        SendVerificationEmail: '發送驗證郵箱',
        SendEmail: '發送郵箱',
        SentTo: '驗證郵件已經發送到你的郵箱',
        PleaseCheckEmail: '中，請查收',
        NoEmailReceived: '沒有收到郵件？請檢查一下垃圾郵件或者點擊',
        FullName: '姓名：',
        PleaseEnterYourName: '請輸入姓名',
        Address: '地址：',
        PleaseSelectProvince: '請選擇省',
        PleaseSelectCity: '請選擇市',
        PleaseSelectCounty: '請選擇縣',
        ModifyAddress: '修改地址',
        PleaseEnterCorrectPhoneNumber: '請輸入正確的手機號',
        PhoneNumberCannotEmpty: '手機號不能為空!',
        UserNameCannotEmpty: '用戶名不能為空!',
        PleaseFillEmailAddress: '請填寫郵件地址!',
        PleaseFillCorrectEmailAddress: '請填寫正確的郵件地址!',
        FileCannotExceed5MB: '上傳文件大小不能超過 5MB，請重新選擇圖片!',
        OldPasswordCannotEmpty: '舊密碼不能為空',
        NewPasswordCannotEmpty: '新密碼不能為空',
        SecondaryPasswordCannotEmpty: '二次密碼不能為空',
        PasswordsEnteredDifferent: '您輸入的兩次密碼不相同!',
        SuccessfullyModified: '修改成功',
        SuccessfullySet: '設置成功',
        PleaseSelectCityOrCounty: '請選擇市或縣區'
    },
  };